var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.objetoEhVazio(_vm.tipoAtivo)
    ? _c("v-container", { staticClass: "container", attrs: { fluid: "" } }, [
        _vm.ativoExistenteOuNovo
          ? _c(
              "div",
              [
                _c(_vm.currentForm, {
                  tag: "component",
                  attrs: {
                    btnCompraClicado: _vm.btnCompraClicado,
                    userToAtivos: _vm.userToAtivos
                  }
                })
              ],
              1
            )
          : _c("div", [
              _c(
                "div",
                { staticClass: "mock" },
                [
                  _c("v-row", { staticClass: "d-flex flex-wrap pb-16 row" }, [
                    _c(
                      "div",
                      { staticClass: "bloco" },
                      [
                        _c(
                          "v-col",
                          { staticClass: "d-flex flex-column align-left py-0" },
                          [
                            _c("span", { staticClass: "text-filelds" }, [
                              _vm._v("Estratégia")
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          { staticClass: "column", attrs: { cols: "1" } },
                          [
                            _c("span", { staticClass: "btn" }, [
                              _vm._v(" Automático ")
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "bloco" },
                      [
                        _c(
                          "v-col",
                          { staticClass: "d-flex flex-column align-left py-0" },
                          [
                            _c("span", { staticClass: "text-filelds" }, [
                              _vm._v("Indice referência")
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          { staticClass: "column", attrs: { cols: "1" } },
                          [
                            _c("span", { staticClass: "btn" }, [
                              _vm._v(" Automático ")
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "bloco" },
                      [
                        _c(
                          "v-col",
                          { staticClass: "d-flex flex-column align-left py-0" },
                          [
                            _c("span", { staticClass: "text-filelds" }, [
                              _vm._v("Forma de Tributação")
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          { staticClass: "column", attrs: { cols: "1" } },
                          [_c("span", { staticClass: "btn" }, [_vm._v("SIM ")])]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "bloco" },
                      [
                        _c(
                          "v-col",
                          { staticClass: "d-flex flex-column align-left py-0" },
                          [
                            _c("span", { staticClass: "text-filelds" }, [
                              _vm._v("Classe ANBIMA")
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          { staticClass: "column", attrs: { cols: "1" } },
                          [
                            _c("span", { staticClass: "btn" }, [
                              _vm._v(" Automático ")
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "bloco" },
                      [
                        _c(
                          "v-col",
                          { staticClass: "d-flex flex-column align-left py-0" },
                          [
                            _c("span", { staticClass: "text-filelds" }, [
                              _vm._v("Formas de Gestão")
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          { staticClass: "column", attrs: { cols: "1" } },
                          [
                            _c("span", { staticClass: "btn" }, [
                              _vm._v(" Automático ")
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "bloco" },
                      [
                        _c(
                          "v-col",
                          { staticClass: "d-flex flex-column align-left py-0" },
                          [
                            _c("span", { staticClass: "text-filelds" }, [
                              _vm._v("FGC")
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          { staticClass: "column", attrs: { cols: "1" } },
                          [
                            _c("span", { staticClass: "btn" }, [
                              _vm._v(" Automático ")
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "bloco" },
                      [
                        _c(
                          "v-col",
                          { staticClass: "d-flex flex-column align-left py-0" },
                          [
                            _c("span", { staticClass: "text-filelds" }, [
                              _vm._v("Total")
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          { staticClass: "column", attrs: { cols: "1" } },
                          [
                            _c("span", { staticClass: "btn" }, [
                              _vm._v(" R$ 500,00 ")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }